import type { HookInitializeInput, HookInitializeOutput } from '@terafile/shared'
import { ApiError } from './api.js'

/**
 * フック領域（暫定テナント）の API クライアント。
 *
 * - 認証不要のため `apiFetch` 経由ではなく直接 fetch
 */

const API_BASE = import.meta.env.VITE_API_URL ?? '/api'

export async function initializeHook(input: HookInitializeInput): Promise<HookInitializeOutput> {
  const res = await fetch(`${API_BASE}/hook/initialize`, {
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    credentials: 'include', // HttpOnly Cookie 受信のため
    body: JSON.stringify(input),
  })
  const body = (await res.json().catch(() => null)) as {
    success?: boolean
    data?: HookInitializeOutput
    error?: { code?: string; message?: string }
  } | null
  if (!res.ok) {
    const err = body?.error
    throw new ApiError(res.status, err?.code ?? 'UNKNOWN', err?.message ?? `HTTP ${res.status}`)
  }
  return body?.data as HookInitializeOutput
}
